export class NotFoundError extends Error {
  constructor(message = 'Not found') {
    super(message);
    this.name = 'NotFoundError';
  }
}

export class ApiError extends Error {
  constructor(message = 'API error', response: Response = null) {
    super(message);
    this.name = 'ApiError';
    this.cause = response;
  }
}

export class NoChangesDetectedError extends Error {
  // this is used to match the error code sent from the server
  static readonly code = 'no_changes_detected';

  constructor(message: string = 'No changes detected') {
    super(message);
    this.name = 'NoChangesDetectedError';
  }
}
